// 找商机-展商端
<template>
  <div>
    <div :class="dataList.length >0 ? 'find-oppirtunity-view' : ''" v-loading="loading">
      <div class="bl-container">
      <opportunity-item 
        v-for="(item, index) in dataList" 
        :key="'opportunity_' + index" 
        :index="index"
        :item="item" 
        styleType="exhibitor" 
        @msg="msgEventInfo"
        @invite="inviteEventInfo"
      ></opportunity-item>
      </div>
      <div class="bl-container op-pagination">
        <el-pagination
          @current-change="pageChange"
          v-if="dataList.length > 0"
          background
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <advertisementVertical :option="$config.advertisement.leftList.opportunity" :leftPosition='true' :top="advertisementTop+'px'"></advertisementVertical>
      <advertisementVertical :option="$config.advertisement.rightList.opportunity" :rightPosition='true' :top="advertisementTop+'px'"></advertisementVertical>
      <div v-show="showNoDataView">
        <hNoData></hNoData>
      </div>
      <ChatWithExhibitor @invite="submitInvite" :action="action" />
      <!-- <v-chat-width-employee-tim v-if="isTIM" /> -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import opportunityItem from '@/components/business/opportunityItem.vue'
import { getCommercialDistrictList, getCommercialDistrictTopList } from '../../api/opportunity.js'
import hNoData from '@/components/hNoData'
import advertisementVertical from '@/components/advertisementVertical'

import { eventMixin } from '@/mixins/event.js'
import { inviteMixin } from '@/mixins/inviteEvent.js'
// import ChatWithEmployeeTim from '@/components/Tim/ChatWithEmployee'
export default {
  mixins: [eventMixin, inviteMixin],
  components: {
    opportunityItem,
    hNoData,
    advertisementVertical,
    // 'v-chat-width-employee-tim': ChatWithEmployeeTim
  },
  data() {
    return {
      advertisementTop: 120,
      loading: false,
      busy: false,
      page: 1,
      testList: ["1","2","3","4"],
      dataList: [],
      total: 0,
      showNoDataView: false,
      action: '',
    }
  },
  computed: {
    ...mapGetters(['exhibitorId', 'subjectType']),
    ...mapGetters(['language', 'isLogin', 'isTIM' ]),
  },
  created() {},
  mounted() {
    window.PC.$RangersEventOpportunity(this.subjectType, 'view')
    this.getData(1);
  },
  methods: {
    // 展商 消息
    msgEventInfo(data) {
      console.log(data)
      if (data.operateSubjectType == 'ACTOR') {
        this.msgEventExh(data, null, 'exhibitors')
      } else {
        if (!data.userAccountId) {
          this.$notify.warning(this.$t('footprints.userAccountId'))
          return false
        }
        this.msgEventPerson(data, '')
      }
    },
    inviteEventInfo(params, index, data) {
      if (data.operateSubjectType == 'ACTOR') {
        this.inviteEventExh(params, index, 'exhibitors')
      } else {
        this.inviteEvent(params, index)
      }
    },
    // 更新邀约状态
    updateInvite(status, index) {
      this.dataList[index]['invite'] = status
    },
    getData (page) {
      var params = {
        pageNum: page,
        pageRows: 10
      }
      this.loading = true;
      let request = null
      if (this.subjectType == 'ACTOR') {
        request = getCommercialDistrictList(params)
      } else {
        request = getCommercialDistrictTopList(params)
      }
      request.then(res => {
        return res.data
      }).then(res => {
        this.loading = false;
        if (res.code === 1000) {
          let data = res.data
          this.dataList = data.list;
          this.total = data.total;
          this.showNoDataView = false;
          if (data.list.length == 0) {
            this.showNoDataView = true;
          }
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    pageChange (page) {
      this.$funcs.scrollToY(0)
      this.getData(page)
    }
  }
}
</script>

<style lang="stylus" scoped>
.find-oppirtunity-view {
  background-color : $color-white;
}
.op-pagination {
  text-align : right;
  margin-top : 60px;
  width : 612px;
  padding-bottom : 60px;
}

</style>
